import { useCallback, useEffect, useState } from "react";

import { useNotify, useSubscribe } from "data/messages/hooks";

export function useSubscribeToWorkflowTemplateUpdate(onUpdate) {
  const [workflows, setWorkflows] = useState([]);
  const notify = useNotify("WORKFLOWS_TEMPLATE");

  useEffect(() => {
    if (workflows.length > 0) {
      onUpdate(workflows);
      setWorkflows([]);
      notify([]);
    }
  }, [workflows, onUpdate, notify]);

  useSubscribe(
    "workflowsTemplate",
    useCallback((wf) => {
      if (wf.size > 0) setWorkflows([...wf]);
    }, [])
  );
}

export default useSubscribeToWorkflowTemplateUpdate;
